module.exports = __webpack_public_path__ + "img/dashboard-section-optimize.af5e06ce.svg";